"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interactions = void 0;
var lex_v2_1 = require("./lex-v2");
Object.defineProperty(exports, "Interactions", { enumerable: true, get: function () { return lex_v2_1.Interactions; } });
